import { render } from "./CompanyPlansBenefitsIndex.vue?vue&type=template&id=0a21cdfe"
import script from "./CompanyPlansBenefitsIndex.vue?vue&type=script&lang=js"
export * from "./CompanyPlansBenefitsIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__